/* Generated file */

export enum AccessibiliteRPLS {
  NonPrecise = "NonPrecise",
  Code00 = "Code00",
  Code11 = "Code11",
  Code12 = "Code12",
  Code13 = "Code13",
  Code19 = "Code19",
  Code99 = "Code99"
}
